import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { Box, Text, Flex, Icon, VStack } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";
import { format } from "date-fns";
const marquee = keyframes `
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-50%, 0, 0);
  }
`;
export default function EventsMarquee({ events, pubId, pubColors, }) {
    var _a, _b, _c;
    const marqueeContentRef = useRef(null);
    const borderColor = (_a = pubColors === null || pubColors === void 0 ? void 0 : pubColors.primary) !== null && _a !== void 0 ? _a : "#6D21E9";
    const bgColor = (_b = pubColors === null || pubColors === void 0 ? void 0 : pubColors.bg) !== null && _b !== void 0 ? _b : "rgba(17, 17, 17, 0.95)";
    const textColor = (_c = pubColors === null || pubColors === void 0 ? void 0 : pubColors.text) !== null && _c !== void 0 ? _c : "white";
    const formatEventDate = (eventDate) => {
        if (!eventDate || eventDate.length < 3)
            return "";
        const date = new Date(`${eventDate[0]}/${eventDate[1]}/${eventDate[2]}`);
        return format(date, "d MMM");
    };
    // Only show if more than 2 events
    if (events.length <= 2)
        return null;
    return (_jsx(Box, { display: { base: "block", md: "none" }, position: "sticky", top: 0, zIndex: 1000, w: "100%", children: _jsx(Box, { w: "100%", bg: bgColor, borderBottom: `1px solid ${borderColor}`, overflow: "hidden", py: 2, children: _jsx(Box, { ref: marqueeContentRef, display: "inline-flex", gap: 6, whiteSpace: "nowrap", animation: `${marquee} ${events.length * 5}s linear infinite`, willChange: "transform", sx: {
                    backfaceVisibility: "hidden",
                    WebkitBackfaceVisibility: "hidden",
                    transform: "translateZ(0)",
                }, children: [...events, ...events].map((event, index) => {
                    const eventDate = formatEventDate(event.event_date);
                    // Format date for URL
                    let dateString = "";
                    if (event.event_date && event.event_date.length >= 3 && pubId) {
                        const date = new Date(`${event.event_date[0]}/${event.event_date[1]}/${event.event_date[2]}`);
                        dateString = format(date, "yyyy-MM-dd");
                    }
                    const eventUrl = pubId && event.uuid && dateString
                        ? `/pub/detail/events/${pubId}?date=${dateString}&id=${event.uuid}`
                        : event.uuid
                            ? `/event/detail/${event.uuid}`
                            : "#";
                    return (_jsx(Link, { to: eventUrl, children: _jsxs(Flex, { alignItems: "center", justifyContent: "center", gap: 3, px: 4, flexShrink: 0, children: [_jsx(Icon, { as: ArrowForwardIcon, color: textColor, boxSize: 6, transform: "rotate(-45deg)" }), _jsxs(VStack, { spacing: 0, alignItems: "flex-start", children: [_jsx(Text, { fontSize: "xs", fontWeight: "400", color: textColor, children: event.event_type }), _jsx(Text, { fontWeight: "400", color: textColor, children: event.event_name })] }), eventDate && (_jsx(Text, { fontSize: "2xl", fontWeight: "700", color: textColor, children: eventDate }))] }, `${event.uuid || index}-${Math.floor(index / events.length)}`) }, `${event.uuid || index}-${Math.floor(index / events.length)}`));
                }) }) }) }));
}
